import type { SiteMetadata } from '../../../../ssr/src/Schema/SiteMetadata';

const initialContextDataState: SiteMetadata = {
  assetsUrl: '',
  contextKey: '',
  environment: 'development',
  experimentFlag: '',
  experimentVariation: '',
  hasActiveCoolerNotification: false,
  hasTemperatureNotification: false,
  isMobile: false,
  language: '',
  siteUrl: '',
  staticUrl: '',
  version: null,
};

export default initialContextDataState;
